import { format } from 'date-fns';
import { z } from 'zod';
import { ConstraintSchema, constraintFields } from '@/lib/account-constraints';
import type { AccountConstraint } from '@/types/schemas';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  ma_gd: z.string().optional(),
  ma_kh: z.string().optional(),
  tk_co: z.string().optional(),
  dien_giai: z.string().optional(),
  tk_no: z.string().optional(),
  ma_unit: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

const baseSchema = z.object({
  ma_gd: z.string().optional().nullable(),
  ma_httt: z.string().optional().nullable(),
  loai_ck: z.string().optional().nullable(),
  ck_tl_nt: z.coerce.number().optional().nullable(),
  transfer_yn: z.boolean().optional().nullable(),

  ma_kh: z.string().optional().nullable(),
  ten_kh: z.string().optional().nullable(),
  ma_so_thue: z.string().optional().nullable(),
  ong_ba: z.string().optional().nullable(),
  dia_chi: z.string().optional().nullable(),
  e_mail: z.string().optional().nullable(),
  dien_giai: z.string().optional().nullable(),

  du_cn_thu: z.number().optional().nullable(),
  ma_nvmh: z.string().optional().nullable(),
  tk: z.string().optional().nullable(),
  ma_tt: z.string().optional().nullable(),

  so_ct: z.string().optional().nullable(),
  ngay_ct: z.string().optional().nullable(),
  so_ct0: z.string().optional().nullable(),
  so_ct2: z.string().optional().nullable(),
  ngay_ct0: z.string().optional().nullable(),

  ma_nt: z.string().optional().nullable(),
  ty_gia: z.coerce.number().optional().nullable(),

  status: z.string().optional().nullable(),

  t_tien_nt2: z.coerce.number().optional().nullable(),
  t_thue_nt: z.coerce.number().optional().nullable(),
  t_tt_nt: z.coerce.number().optional().nullable(),
  chi_tiet: z
    .array(
      z.object({
        ma_dv: z.string().optional().nullable(),
        tk_vt: z.string().optional().nullable(),
        so_luong: z.coerce.number().optional().nullable(),
        ...constraintFields
      })
    )
    .optional()
});

export const formSchema = (constraints: AccountConstraint[] = []) => ConstraintSchema(baseSchema, constraints);
export type FormSchema = z.infer<typeof baseSchema>;

export const initialFormValues: FormSchema = {
  ma_gd: '',
  ma_httt: 'TMM',
  loai_ck: '2',
  ck_tl_nt: 0,
  transfer_yn: false,

  ma_kh: '',
  ten_kh: '',
  ma_so_thue: '',
  ong_ba: '',
  dia_chi: '',
  e_mail: '',
  dien_giai: '',

  du_cn_thu: 0,
  ma_nvmh: '',
  tk: '',
  ma_tt: '',

  so_ct: '',
  ngay_ct: format(new Date(), 'yyyy-MM-dd'),
  so_ct0: '',
  so_ct2: '',
  ngay_ct0: format(new Date(), 'yyyy-MM-dd'),

  ma_nt: '',
  ty_gia: 1,

  status: '5',

  t_tien_nt2: 0,
  t_thue_nt: 0,
  t_tt_nt: 0
};
